import getTimezoneOffset from '@teetsh/app/src/utils/time/getTimezoneOffset';

export default function deserializeDateFromServer(
  date: Date,
  loc: string,
): Date {
  const userOffset = getTimezoneOffset(loc, date);

  const localOffset = date.getTimezoneOffset();
  const localOffsetMillis = 60 * 1000 * localOffset;

  const localMidnight = new Date(
    date.getTime() + userOffset + localOffsetMillis,
  );
  return localMidnight;
}
